import React, {Component} from "react"
import {Row, Col} from "react-bootstrap"
import moment from "moment"

import authentication from "@irati/auth"
import adminReportingService from "@irati/adminReporting/services/adminReporting"
import Loading from "@irati/ui/src/Loading"
import {hangPromise} from "@irati/utils/promise"
import {OnboardingReportStep} from "@irati/types"
import theme from "@irati/ui/src/global/theme"
import {adminDashboardTracking} from "@irati-tracking/admin"

import ActivationRate from "../../components/Dashboard/ActivationRate"
import BusinessStatistics from "../../components/Dashboard/BusinessStatistics"
import Tile from "../../components/Dashboard/Tile"
import Integrations from "../../components/Dashboard/Integrations"
import resourceHub from "../../images/resourceHub.png"
import Onboarding from "../../components/Dashboard/Onboarding"
import Reporting from "../../components/Dashboard/Reporting"
import Benefits from "../../components/Dashboard/Benefits"
import {RightCard, LeftCard, StyledGrid} from "./styled"

interface Props {}
interface State {
  load: Promise<void>
  percentage?: number
  regions?: number
  teams?: number
  users?: number
  metrics?: OnboardingReportStep[]
}

class Dashboard extends Component<Props, State> {
  state: State = {
    load: hangPromise(),
    percentage: undefined,
    regions: undefined,
    teams: undefined,
    users: undefined,
    metrics: undefined
  }

  componentDidMount() {
    const overviewLoad = adminReportingService.getBusinessOverview({businessId: authentication.business().uuid}).then(({overview}) => {
      const {activated, regions, teams, users} = overview
      this.setState({percentage: activated.toFixed(2) * 100, regions, teams, users})
    })
    const onboarding = adminReportingService
      .getOnboarding(authentication.business().uuid, {fetchPolicy: "network-only"})
      .then(({reports}) => {
        this.setState({metrics: reports})
      })

    const load = Promise.all([overviewLoad, onboarding])
    this.setState({load})
  }

  render() {
    const {percentage, regions, teams, users, metrics, load} = this.state
    const isBusiness45DaysOld = moment(moment().add(-45, "days")).isAfter(authentication.business().metadata.createdAt)

    return (
      <Loading load={load}>
        <StyledGrid>
          <Row>
            {isBusiness45DaysOld && (
              <>
                <Col xs={12}>
                  <Benefits />
                </Col>
                <Col xs={12}>
                  <Reporting />
                </Col>
                <Onboarding reportingSteps={metrics} />
              </>
            )}
            {!isBusiness45DaysOld && (
              <>
                <Col xs={12}>
                  <Onboarding reportingSteps={metrics} expanded />
                </Col>
                <Col xs={12}>
                  <Benefits />
                </Col>
                <Col xs={12}>
                  <Reporting />
                </Col>
              </>
            )}
            <Col xs={12} lg={6}>
              <LeftCard fixedHeight marginBottom={2} padding={[3]}>
                <ActivationRate percentage={percentage} />
              </LeftCard>
            </Col>
            <Col xs={12} lg={6}>
              <RightCard fixedHeight marginBottom={2} padding={[3]}>
                <BusinessStatistics regions={regions} teams={teams} users={users} />
              </RightCard>
            </Col>
          </Row>
          <Integrations />
          <Row>
            <RightCard margin={[3, 2, 0, 2]}>
              <Tile
                title="admin.components.dashboardTile.resourceHub.title"
                link="admin.components.dashboardTile.resourceHub.link"
                text="admin.components.dashboardTile.resourceHub.text"
                image={resourceHub}
                color={theme.colors.primary1_50}
                onClick={adminDashboardTracking.clickResourceHub}
              />
            </RightCard>
          </Row>
        </StyledGrid>
      </Loading>
    )
  }
}

export default Dashboard
